var map = {
	"./IconAddress.vue": 3464,
	"./IconArrowLeft.vue": 398,
	"./IconArrowLeftSmall.vue": 8808,
	"./IconArrowRight.vue": 8339,
	"./IconArrowRightSmall.vue": 2676,
	"./IconBurger.vue": 9057,
	"./IconCart.vue": 9355,
	"./IconCheckmark.vue": 2868,
	"./IconCheckmarkCircle.vue": 8715,
	"./IconChevronDown.vue": 863,
	"./IconChevronLeft.vue": 4326,
	"./IconChevronRight.vue": 9086,
	"./IconChevronUp.vue": 9020,
	"./IconClock.vue": 3482,
	"./IconClose.vue": 1262,
	"./IconCompare.vue": 2433,
	"./IconCopy.vue": 8857,
	"./IconDesign.vue": 9998,
	"./IconEdit.vue": 7669,
	"./IconEmail.vue": 6793,
	"./IconEye.vue": 1163,
	"./IconEyesOff.vue": 7679,
	"./IconEyesOn.vue": 6491,
	"./IconFacebook.vue": 7504,
	"./IconFilter.vue": 8389,
	"./IconGlobal.vue": 1297,
	"./IconHeartEmpty.vue": 2512,
	"./IconLinkedin.vue": 67,
	"./IconLocation.vue": 9844,
	"./IconMinus.vue": 8587,
	"./IconMoreVertical.vue": 9327,
	"./IconPdf.vue": 2246,
	"./IconPhone.vue": 2364,
	"./IconPlay.vue": 1152,
	"./IconPlus.vue": 5062,
	"./IconPlusCircle.vue": 3291,
	"./IconRhomb.vue": 5410,
	"./IconSearch.vue": 4839,
	"./IconSettings.vue": 5145,
	"./IconShare.vue": 4651,
	"./IconTarget.vue": 9129,
	"./IconTelegram.vue": 5560,
	"./IconTrash.vue": 2643,
	"./IconTwitter.vue": 7708,
	"./IconViber.vue": 4568,
	"./IconVideo.vue": 1773,
	"./IconWhatsapp.vue": 4017
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7539;
module.exports = webpackAsyncContext;